export default __webpack_public_path__ + "static/media/8e06e1874547f6813a333be97e2b57ad1600818651639.1fbefda2.webp";